import { API } from ".";

export const updateEventAlerts = async ({ token, eventId, overrides }) => {
    try {
        const response = await API.put(
            `/events/${eventId}/alerts`,
            { overrides },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
